// extracted by mini-css-extract-plugin
module.exports = {"languageSetting":"style_languageSetting__a1p5b","title":"style_title__Rocou","tip":"style_tip__phUxn","learnMore":"style_learnMore__w2fCP"};